import { components } from "@certn/api/generated-schemas/client-portal";
import { createContext, SetStateAction } from "react";

export interface AtsIntegration {
  // Provided by the server when the integration is created, not sent by the client.
  api_key: string;
  integration_id: string;
  // Sent by the client
  customer_group_id: string;
  report_url_type: components["schemas"]["ReportUrlTypeEnum"];
}

export interface WorkableIntegrationContextType {
  atsIntegrationData: AtsIntegration;
  currentStep: number;
  setAtsIntegration: (value: SetStateAction<AtsIntegration>) => void;
  goToNextStep: () => void;
  goToPrevStep: () => void;
}

export const WorkableIntegrationContext =
  createContext<WorkableIntegrationContextType>({
    atsIntegrationData: {
      api_key: "",
      integration_id: "",
      customer_group_id: "",
      report_url_type: "CLIENT_PORTAL_URL",
    },
    setAtsIntegration: () => {},
    currentStep: 0,
    goToNextStep: () => {},
    goToPrevStep: () => {},
  });
